<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="text-ontick-carbon-900 relative dark:text-gray-300">
    <div
      class="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8"
    >
      <p
        class="text-ontick-green-600 text-base font-semibold uppercase tracking-wider"
      >
        Vantagens
      </p>
      <p class="mt-2 text-2xl font-extrabold tracking-tight sm:text-4xl">
        {{ data.title }}
      </p>
      <p
        class="text-md mx-auto mt-5 max-w-prose text-gray-500 dark:text-gray-400 sm:text-xl"
        v-if="data.subtitle"
      >
        {{ data.subtitle }}
      </p>
      <div class="mt-12">
        <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          <div
            v-for="(feature, index) in data.data"
            :key="index"
            class="h-full pt-6"
          >
            <div
              class="border-ontick-steel-300 dark:bg-ontick-graphite-500 flow-root h-full rounded-lg border-2 bg-transparent px-6 pb-8 dark:border-none"
            >
              <div class="-mt-6">
                <div>
                  <span
                    class="bg-ontick-green-700 inline-flex h-[50px] w-[50px] items-center justify-center rounded-md shadow-lg"
                  >
                    <i
                      v-html="feature.icon"
                      v-if="feature.icon"
                      class="max-h-[24px] max-w-[24px]"
                    ></i>
                    <span v-else class="text-xl font-bold text-white">{{
                      index + 1
                    }}</span>
                  </span>
                </div>
                <h3
                  class="mt-8 text-lg font-medium tracking-tight"
                  v-if="feature.title"
                >
                  {{ feature.title }}
                </h3>
                <p
                  class="mt-5 text-base text-gray-500 dark:text-gray-400"
                  v-if="feature.description"
                >
                  {{ feature.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
  },
};
</script>
